import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscriptionAccess } from '../hooks/useSubscriptionAccess';
import { isSubscriptionModuleEnabled } from '../config/subscriptionConfig';

/**
 * Composant de protection des routes basé sur l'abonnement
 * - Si le module est désactivé : Accès autorisé pour tous
 * - Si le module est activé :
 *   - Premium/Offert : Accès autorisé
 *   - Gratuit/Expiré/Aucun : Redirection vers la page d'abonnement
 */
function SubscriptionGuard({ children }) {
  const moduleEnabled = isSubscriptionModuleEnabled();
  const { loading, hasPremiumAccess } = useSubscriptionAccess();

  // Si le module est désactivé, autoriser l'accès
  if (!moduleEnabled) {
    return children;
  }

  // Pendant le chargement, afficher un loader
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Vérification de votre abonnement...</p>
        </div>
      </div>
    );
  }

  // Si l'utilisateur a un accès premium, autoriser l'accès
  if (hasPremiumAccess) {
    return children;
  }

  // Sinon, rediriger vers la page d'abonnement avec un message
  return <Navigate to="/subscription" state={{ message: 'Cette fonctionnalité nécessite un abonnement premium.' }} />;
}

export default SubscriptionGuard;
